<app-product-table [isArchive]="false"

></app-product-table>

